import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { ContactService } from '../../services/contact.service';
import { InquiryResponse } from '../../models/inquiry.model';
import { ContactForm } from '../../models/contact-form.model';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  contactFormGroup!: FormGroup;
  submitError = '';
  submitSuccess: InquiryResponse | null = null;
  isSubmitting = false;

  constructor(private contactService: ContactService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.contactService
      .initializeService()
      .then(() => {
        const source = this.route.snapshot.queryParamMap.get('source') || 'contact';
        const type = this.route.snapshot.queryParamMap.get('type') || this.mapSourceToInquiryType(source);

        this.contactFormGroup = new FormGroup({
          first_name: new FormControl('', [Validators.required, Validators.minLength(2)]),
          last_name: new FormControl('', [Validators.required, Validators.minLength(2)]),
          email: new FormControl('', [Validators.required, Validators.email]),
          phone: new FormControl('', [Validators.required, Validators.minLength(7)]),
          company: new FormControl(''),
          comments: new FormControl('', [Validators.required, Validators.minLength(10)]),
          source_page: new FormControl(source, [Validators.required]),
          inquiry_type: new FormControl(type, [Validators.required])
        });
      })
      .catch((error) => {
        this.submitError = 'Unable to initialize the contact form.';
        console.error('Error initializing contact service', error);
      });
  }

  submitContactDetails(): void {
    this.submitError = '';
    this.submitSuccess = null;

    if (this.contactFormGroup.invalid) {
      this.contactFormGroup.markAllAsTouched();
      this.submitError = 'Please fill out all required fields correctly.';
      return;
    }

    this.isSubmitting = true;
    const payload = this.contactFormGroup.getRawValue() as ContactForm;

    this.contactService.submitContactForm(payload).subscribe({
      next: (response) => {
        this.submitSuccess = response;
        this.contactFormGroup.reset({
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
          company: '',
          comments: '',
          source_page: payload.source_page,
          inquiry_type: payload.inquiry_type
        });
        this.isSubmitting = false;
      },
      error: (error) => {
        this.submitError = error?.error?.detail || 'There was an error submitting your request. Please try again.';
        this.isSubmitting = false;
      }
    });
  }

  private mapSourceToInquiryType(source: string): string {
    const normalized = source.toLowerCase();
    if (normalized.includes('commercial')) {
      return 'commercial';
    }
    if (normalized.includes('transportation')) {
      return 'transportation';
    }
    if (normalized.includes('retail')) {
      return 'retail';
    }
    if (normalized.includes('partnership')) {
      return 'partnership';
    }
    if (normalized.includes('holdings') || normalized.includes('search')) {
      return 'innovation';
    }
    return 'general';
  }
}
